import { CurrentUser } from '../../../models/CurrentUser'

export default function allowedCourseFilterOptions(currentUser?: CurrentUser) {
  return {
    favorites: true,
    type: true,
    categories: true,
    status: {
      draft:
        currentUser?.permissions.learning_item.view_draft || currentUser?.permissions.learning_item.view_draft_global,
      deprecated: currentUser?.permissions.learning_item.view_deprecated,
      published: true,
    },
  }
}
